/* global axios */
import platformPolicyAPI from 'dashboard/api/platformPolicy';
import {
  isWhatsappFreeInbox,
  normalizeAccountId,
  normalizePlatformPolicy,
  unavailablePlatformPolicy,
} from './platformPolicyRules';

const policyCache = new Map();
const pendingRequests = new Map();

const reportAccessFailure = (operation, error) => {
  const status = error?.response?.status || 'network_error';
  // eslint-disable-next-line no-console
  console.error(`Platform access ${operation} failed.`, { status });
};

export const loadPlatformPolicy = accountId => {
  const normalizedAccountId = normalizeAccountId(accountId);
  if (!normalizedAccountId) return Promise.resolve(unavailablePlatformPolicy());
  if (policyCache.has(normalizedAccountId)) {
    return Promise.resolve(policyCache.get(normalizedAccountId));
  }
  if (pendingRequests.has(normalizedAccountId)) {
    return pendingRequests.get(normalizedAccountId);
  }

  const request = platformPolicyAPI
    .get(normalizedAccountId)
    .then(({ data }) => {
      const policy = normalizePlatformPolicy(data);
      if (policy.policyAvailable) policyCache.set(normalizedAccountId, policy);
      return policy;
    })
    .catch(error => {
      reportAccessFailure('policy request', error);
      return unavailablePlatformPolicy();
    })
    .finally(() => pendingRequests.delete(normalizedAccountId));

  pendingRequests.set(normalizedAccountId, request);
  return request;
};

export const loadInboxPlatformService = async (route, accountId) => {
  if (route.name !== 'settings_inbox_show') return '';

  const normalizedAccountId = normalizeAccountId(accountId);
  const inboxId = normalizeAccountId(route.params?.inboxId);
  if (!normalizedAccountId || !inboxId) return null;

  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${normalizedAccountId}/inboxes`
    );
    const inbox = data.payload?.find(item => String(item.id) === inboxId);
    return isWhatsappFreeInbox(inbox) ? 'whatsapp_free' : '';
  } catch (error) {
    reportAccessFailure('inbox classification', error);
    return null;
  }
};
